import { render, staticRenderFns } from "./GerenciarUsuarioListagem.vue?vue&type=template&id=0a530efc&scoped=true"
import script from "./GerenciarUsuarioListagem.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarioListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a530efc",
  null
  
)

export default component.exports